import { Stack } from '@/components/layout';
import { useSelectContext } from '@/components/ui/select/select-context';
import { useStyles } from '@/components/ui/select/styles';
import type { SelectItemProps } from '@/components/ui/select/types';
import { Text } from '@/components/ui/text';
import { useScaling } from '@/hooks';
import { TypographyToken } from '@/theme/typography';
import { memo } from 'react';
import { Pressable } from 'react-native';

export const SelectItem = memo(
  ({
    value,
    label,
    style,
    disabled: disabledProp,
    isSelected,
    itemTextVariant = 'Font Inter/Subtitle/Regular 12px',
  }: SelectItemProps & {
    disabled?: boolean;
    isSelected?: boolean;
    itemTextVariant?: TypographyToken;
  }) => {
    const { setValue, disabled } = useSelectContext();
    const styles = useStyles();
    const { scale } = useScaling();

    const isDisabled = disabledProp ?? disabled;
    const displayLabel = label ?? value;

    return (
      <Pressable
        disabled={isDisabled}
        accessibilityRole="button"
        accessibilityState={{ selected: Boolean(isSelected), disabled: isDisabled }}
        onPress={() => setValue(value)}
        style={[
          styles.item,
          isDisabled ? styles.disabled : undefined,
          isSelected ? styles.itemSelected : undefined,
          style,
        ]}>
        <Text variant={itemTextVariant} style={styles.itemLabel} numberOfLines={1}>
          {displayLabel}
        </Text>
        <Stack style={{ height: scale(0.1) }} />
      </Pressable>
    );
  },
);

SelectItem.displayName = 'Select.Item';
